import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import Offer from "./pages/Offer/Offer";
import Licence from "./pages/Licence/Licence";
import Policy from "./pages/Policy/Policy";
import Contact from "./pages/Contact/Contact";
import Banned from "./pages/Banned/Banned";
import HowOrder from "./pages/HowOrder/HowOrder";
import SignUp from "./pages/SignUp/SignUp";
import SignIn from "./pages/SignIn/SignIn";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AddCompany from "./pages/AddCompany/AddCompany";
import AdminAddCompany from "./pages/AdminAddCompany/AdminAddCompany";
import "bootstrap/dist/css/bootstrap.min.css";
import MyOffers from "./pages/MyOffers/MyOffers";
import Edit from "./pages/Edit/Edit";
import Promotion from "./pages/Promotion/Promotion";
import Extend from "./pages/Extend/Extend";
import Copyright from "./pages/Copyright/Copyright";
import ErrorBoundary from "./ErrorBoundary";
import MyBills from "./pages/MyBills/MyBills";
import BillDetails from "./pages/BillDetails/BillDetails";
import AdminBills from "./pages/AdminBills/AdminBills";
import AdminUsers from "./pages/AdminUsers/AdminUsers";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import UserDetails from "./pages/AdminUsers/UserDetails/UserDetails";
import AdminOffers from "./pages/AdminOffers/AdminOffers";
import OfferDetails from "./pages/AdminOffers/OfferDetails/OfferDetails";

axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? ""
    : "http://localhost:5000";

const theme = createTheme({
  palette: {
    primary: {
      light: "#ffc246",
      main: "#ff9100",
      dark: "#c56200",
      contrastText: "#000",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
});

theme.typography.body1 = {
  fontSize: "10px",
  "@media (min-width: 720px)": {
    fontSize: "15px",
  },
};

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <Switch>
              <Route exact path="/" component={App} />

              <Route exact path="/offer" component={Offer} />
              <Route exact path="/licence" component={Licence} />
              <Route exact path="/policy" component={Policy} />
              <Route exact path="/contact" component={Contact} />
              <Route exact path="/banned" component={Banned} />
              <Route exact path="/how-to-order" component={HowOrder} />
              <Route exact path="/signup" component={SignUp} />
              <Route exact path="/signin" component={SignIn} />
              <Route exact path="/forgot-password" component={ForgotPassword} />
              <Route exact path="/addcompany" component={AddCompany} />
              <Route exact path="/my-offers" component={MyOffers} />
              <Route exact path="/copy" component={Copyright} />
              <Route exact path="/adminaddcompany" component={AdminAddCompany} />

              <Route exact path="/edit/offer/:id" component={Edit} />
              <Route exact path="/promotion/offer/:id" component={Promotion} />
              <Route exact path="/extend/offer/:id" component={Extend} />

              <Route exact path="/my-bills" component={MyBills} />
              <Route exact path="/admin/bills" component={AdminBills} />
              <Route exact path="/admin/users/:id" component={UserDetails} />
              <Route exact path="/admin/users" component={AdminUsers} />

              <Route exact path="/admin/offers" component={AdminOffers} />
              <Route exact path="/admin/offers/:id" component={OfferDetails} />

              <Route
                exact
                path="/my-bills/details/:id"
                render={() => <BillDetails />}
              />

              <Route
                exact
                path="/admin/bills/details/:id"
                render={() => <BillDetails isAdmin />}
              />

              {/* ZAWSZE NA KOŃCU */}
              <Route
                exact
                path="/:voivodeship/:truck"
                component={App}
              />
            </Switch>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();